import type { FaireProductEntity } from "../../entity_types/product";

export const p_jasbczqu5a: FaireProductEntity = {
  token: "p_jasbczqu5a",
  type: "product",
  name: "celebrate watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5f02978ea1b999bcd36558a969812b2f4bc5df0480deeb27bac18c8b780abdf2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a8579204a678ee538787355feeeb93ebca760189d3fc57948c7376af838da875.jpeg",
    "https://cdn.faire.com/fastly/2183b67b745c71910be8479c4df769781b0414c0bc57f7667f44f509a719a035.jpeg",
    "https://cdn.faire.com/fastly/9fe3260ae3f888e6da22ccf7a4ce6fcc712a2381f262a32cad10155492380042.jpeg",
    "https://cdn.faire.com/fastly/4e98fc67c3f0f47a41d11aa2453c332ae3b6a41d33ac4472470b92e4310e0ae0.jpeg",
    "https://cdn.faire.com/fastly/955ba7bfabc72c4135c82ebe40148733e9b426f456a8762f82ab9f7f077e9aa9.jpeg",
    "https://cdn.faire.com/fastly/b80697d785d307ec5a06db6835e1a74cd07d8a348c9e8ea9d8a1508dc672fcfe.jpeg",
  ],
  priceDollars: 12,
  description:
    "An invitation to slow down and paint something pretty.\n\nThe Celebrate Watercolor Workbook is filled with twelve party illustrations — balloons, wrapped gift, a confetti birthday cake, a pup in a party hat, and more — each one outlined and ready to paint. Simple step-by-step instructions walk you through every illustration, and most paintings take about thirty minutes start to finish — so even if you've never painted before, you'll have something lovely in your hands by the end.\n\nA sweet birthday gift, or an easy party activity. No experience needed, just a set of watercolors and a little time.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:07.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
